// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3xi3-","subheader":"ReorderModal_subheader__2qdnX","listWrap":"ReorderModal_listWrap__3kGJg"};